const initState = {
    authError: null
}

const authReducer = (state = initState, action) => {
    switch(action.type) {
        case "SIGNUP_SUCCESS":
            console.log("authReducer:: Sign up success");
            return {
                ...state,
                authError: null
            };
        case "SIGNUP_ERROR":
            console.log("authReducer:: Sign up error");
            return {
                ...state,
                authError: action.err.message
            };
        case "SIGNOUT_SUCCESS":
            console.log("authReducer:: Sign out success");
            return state;
        case "SIGNIN_SUCCESS":
            console.log("authReducer:: Sign in success");
            return {
                ...state,
                authError: null
            };
        case "SIGNIN_ERROR":
            return {
                ...state,
                authError: action.err.message
            };
        default:
            return state;
    }
};

export default authReducer;